import React from 'react';
import { ScrollFadeIn } from './ScrollFadeIn';
export function PostCTAReassurance() {
  return <section className="pt-6 pb-10 bg-slate-900" data-id="element-531">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-532">
        <ScrollFadeIn data-id="element-533">
          <p className="text-2xl font-serif text-slate-50 mb-6" data-id="element-534">
            Still here? Let me be direct.
          </p>
        </ScrollFadeIn>

        <ScrollFadeIn delay={0.1} data-id="element-535">
          <p className="text-lg text-slate-300 leading-relaxed mb-4" data-id="element-536">
            If you're over 40, running on caffeine and willpower, waking up
            exhausted, and watching your midsection get harder to shift — this
            system was built specifically for you.
          </p>
        </ScrollFadeIn>

        <ScrollFadeIn delay={0.2} data-id="element-537">
          <p className="text-lg text-slate-300 leading-relaxed mb-6" data-id="element-538">
            It's not theory. It's not generic wellness advice. It's a targeted
            biological protocol for the exact hormonal environment of a stressed
            40+ body.
          </p>
        </ScrollFadeIn>

        <ScrollFadeIn delay={0.3} data-id="element-539">
          <p className="text-xl font-bold text-amber-500" data-id="element-540">
            You've already tried the harder path. This is the smarter one.
          </p>
        </ScrollFadeIn>
      </div>
    </section>;
}